module.exports = __webpack_public_path__ + "static/media/freight-people-home-bg.7f99d702.jpg";